// Dependencies
import { FC, ReactNode } from 'react';
import { Box, useMediaQuery, useTheme } from '@mui/material';
import PerfectScrollbar from 'react-perfect-scrollbar';

// Components
import Header from './Header';
import Sidebar from './Sidebar';

// Styles
import styles from './styles';

// Interfaces
interface IMainLayoutProps {
  children: ReactNode;
  contentWrapperSx: any;
  /** Hide the page-level horizontal PerfectScrollbar rail (PDF split view scales instead). */
  suppressScrollX?: boolean;
}

// Export main layout
export const MainLayout: FC<IMainLayoutProps> = ({
  children,
  contentWrapperSx,
  suppressScrollX = false,
}) => {
  // Theme
  const theme = useTheme();

  // Check window size
  const isTablet = useMediaQuery(theme.breakpoints.up('md'));

  // Return main layout
  return (
    <Box sx={styles.layout}>
      {isTablet && <Sidebar />}
      <Box sx={styles.aside}>
        <Header />
        <Box
          component={PerfectScrollbar}
          options={{ suppressScrollX }}
          sx={(t) => ({
            ...styles.content(t),
            ...contentWrapperSx,
            ...(suppressScrollX ? { overflowX: 'hidden' } : {}),
          })}
        >
          {children}
        </Box>
      </Box>
    </Box>
  );
};
